import React, {createContext, useContext, useState, ReactNode} from 'react';
import background from './../assets/settings_background.jpg';
import waveBottom from './../assets/bottom_wave_modal.png';
import waveTop from './../assets/top_wave_modal.png';
import gameOverBackground from './../assets/modal_game_over.jpg';
import logo_start from './../assets/logo_new.png';
// @ts-ignore
import videoFile from './../assets/video_live_background.mp4';
import buttonUi from './../assets/button_ui.png';
import cadr1 from './../assets/cadr_1_heart.png';
import cadr2 from './../assets/cadr_2_heart.png';
import cadr3 from './../assets/cadr_3_heart.png';
import startInRound from './../assets/start_in_round.png';
import totalRate from './../assets/total_rate.png';

//game figures
import angle_left_bottom from './../assets/figures/angle_left_bottom.png';
import angle_right_bottom from './../assets/figures/angle_right_bottom.png';
import angle_right_top from './../assets/figures/angle_right_top.png';
import angle_left_top from './../assets/figures/angle_left_top.png';

import double_col from './../assets/figures/double_col.png';
import double_square from './../assets/figures/double_square.png';

import five_row_col from './../assets/figures/five_row_col.png'
import four_col_row from './../assets/figures/four_col_row.png'

import mini_angle_left_bottom from './../assets/figures/mini_angle_left_bottom.png';
import mini_angle_right_bottom from './../assets/figures/mini_angle_right_bottom.png';
import mini_angle_left_top from './../assets/figures/mini_angle_left_top.png';
import mini_angle_right_top from './../assets/figures/mini_angle_right_top.png';

import single from './../assets/figures/single.png';

import triple_row_col from './../assets/figures/triple_row_col.png';

type MediaContextType = boolean;

export const MediaContext = createContext<MediaContextType | undefined>(undefined);

interface MediaProviderProps {
    children: ReactNode;
}

const pictures = [
    double_col,
    double_square,
    five_row_col,
    four_col_row,
    mini_angle_left_bottom,
    mini_angle_right_bottom,
    mini_angle_left_top,
    mini_angle_right_top,
    single,
    triple_row_col,
    angle_left_bottom,
    angle_right_bottom,
    angle_left_top,
    angle_right_top,
    logo_start,
    background,
    waveBottom,
    waveTop,
    gameOverBackground,
    buttonUi,
    cadr1,
    cadr2,
    cadr3,
    totalRate,
    startInRound
];

export const MediaProvider: React.FC<MediaProviderProps> = ({children}) => {
    const [isLoaded, setLoaded] = useState<number>(0);

    return (
        <MediaContext.Provider value={isLoaded === pictures.length}>
            <>
                {children}
                {pictures.map(src => (
                    <img onLoad={() => {
                        setLoaded(prevState => prevState + 1);
                    }} style={{opacity: 0, position: 'fixed', pointerEvents: 'none'}} src={src} alt=""/>
                ))}
            </>
        </MediaContext.Provider>
    );
};


export const useMedia = () => {
    const context = useContext(MediaContext);
    if (context === undefined) {
        throw new Error('useMedia must be used within a MediaProvider');
    }
    return context;
};
